/* カードのホバー（PC）・タッチ（スマホ）で色だけ付ける */
(function () {
  'use strict';
  if (window.__mxHoverLoaded) return;
  window.__mxHoverLoaded = true;

  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };
  var hovered = null;

  /* ALL のカードに印を付ける（配色は CSS 側でレインボー） */
  function tagAll() {
    document.querySelectorAll('.mx-card').forEach(function (c) {
      var nm = c.querySelector('.mx-name');
      var t = nm ? (nm.textContent || '').trim().toUpperCase() : '';
      if (t === 'ALL') c.classList.add('mx-card--all');
    });
  }

  /* スマホのキャラ名帯：ALL のときだけレインボー */
  function syncNamebar() {
    document.querySelectorAll('.mx-namebar').forEach(function (b) {
      var t = (b.textContent || '').trim().toUpperCase();
      b.classList.toggle('is-all', t === 'ALL');
    });
  }

  function watchNamebar() {
    if (!('MutationObserver' in window)) return;
    document.querySelectorAll('.mx-namebar').forEach(function (b) {
      if (b.dataset.mxAllWatch === '1') return;
      b.dataset.mxAllWatch = '1';
      new MutationObserver(syncNamebar).observe(b, { childList: true, characterData: true, subtree: true });
    });
    syncNamebar();
  }

  function paint(card, on) {
    if (!card || card.classList.contains('is-active')) return;
    if (card.classList.contains('mx-card--all')) return; /* CSS に任せる */
    var edge = card.getAttribute('data-edge');
    var inner = card.getAttribute('data-inner');
    var nm = card.querySelector('.mx-name');
    if (on) {
      if (inner) card.style.background = inner;
      if (edge) card.style.borderColor = edge;
      if (nm && edge) {
        nm.style.background = edge;
        nm.style.color = '#fff';
        nm.style.boxShadow = 'inset 0 2px 0 0 ' + edge;
      }
    } else {
      card.style.background = '';
      card.style.borderColor = '';
      if (nm) { nm.style.background = ''; nm.style.color = ''; nm.style.boxShadow = ''; }
    }
  }

  document.addEventListener('mouseover', function (e) {
    if (isMobile()) return;
    var t = e.target;
    var card = t && t.closest ? t.closest('.mx-card') : null;
    if (card === hovered) return;
    if (hovered) paint(hovered, false);
    hovered = card;
    if (card) paint(card, true);
  }, true);

  document.addEventListener('mouseleave', function () {
    if (hovered) { paint(hovered, false); hovered = null; }
  }, true);

  window.addEventListener('blur', function () {
    if (hovered) { paint(hovered, false); hovered = null; }
  });

  /* スマホ：タッチ中だけ同じ色を乗せる */
  document.addEventListener('touchstart', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.mx-card') : null;
    if (!card) return;
    if (hovered) paint(hovered, false);
    hovered = card;
    paint(card, true);
  }, { passive: true });

  ['touchend', 'touchcancel'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      if (hovered) { paint(hovered, false); hovered = null; }
    }, { passive: true });
  });

  function boot() { tagAll(); watchNamebar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('click', function () { setTimeout(syncNamebar, 60); }, true);
})();
